import React from 'react';
import { Box, Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';

import { ListingFiltersValues } from './types';
import { EventsListing } from './EventsListing';
import { ListingFilters } from './ListingFilters';
import { INITIAL_FILTERS } from '../../constants';
import { CalendarEventCard } from '../card';
import { useLocation } from 'react-router-dom';

export const Listing = () => {
  const { search } = useLocation();
  const eventId = new URLSearchParams(search).get('eventId');

  const form = useForm<ListingFiltersValues>({ defaultValues: INITIAL_FILTERS });

  return (
    <>
      {eventId && <CalendarEventCard id={eventId} />}

      <FormProvider {...form}>
        <Stack gap="0.5rem" sx={{ flex: 1, minHeight: 0 }}>
          <ListingFilters />

          <Box sx={{ flex: 1, minHeight: 0 }}>
            <EventsListing />
          </Box>
        </Stack>
      </FormProvider>
    </>
  );
};
